.container {
  position: relative;
  /* max-height: 50rem; */
  /* display: grid; */
  /* mix-blend-mode: plus-lighter; */
  transform-origin: var(--hud-origin, 50% 0);
}

.content {
  /* position: relative; */
  display: contents;
  /* display: contents; */
  /* padding: var(--mantine-spacing-md); */
}

.background {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: radial-gradient(
    ellipse at 50% 50%,
    oklch(10% 0.02 var(--hud-primary-hue)) 0%,
    oklch(25% 0.05 var(--hud-primary-hue)) 60%,
    oklch(40% 0.04 var(--hud-primary-hue)) 100%
  );
  mix-blend-mode: plus-lighter;
  opacity: calc(var(--hud-background-opacity, 0) * var(--hud-transition-progress));
  clip-path: var(--hud-clip-path);
  /* transform-origin: inherit; */
  scale: var(--hud-transition-progress);
  /* animation: background-pulse 4s ease-in-out infinite; */
}

@keyframes background-pulse {
  0%,
  100% {
    opacity: var(--hud-background-opacity, 0.2);
  }
  50% {
    opacity: calc(var(--hud-background-opacity, 0.2) * 1.5);
  }
}

.glow {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: oklch(50% 0.1 var(--hud-accent-hue) / 1);
  border-radius: 10rem;
  mix-blend-mode: plus-lighter;
  opacity: var(--hud-glow-opacity, 0);
  filter: blur(1rem);
  /* animation: glow-pulse 4s ease-in-out infinite; */
}

@keyframes glow-pulse {
  0%,
  100% {
    filter: blur(1rem);
    opacity: var(--hud-glow-opacity, 0.3);
  }
  50% {
    filter: blur(2rem);
    opacity: calc(var(--hud-glow-opacity, 0.3) * 1.5);
  }
}

.border {
  position: absolute;
  inset: 0;
  z-index: var(--hud-border-z-index);
  pointer-events: none;
  background: oklch(60% 0.15 var(--hud-primary-hue));
  opacity: var(--hud-transition-progress);
  clip-path: var(--hud-stroke-path);
  transform-origin: inherit;
  scale: var(--hud-transition-progress);
}

.corner {
  --particle-duration: 8s;

  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background: oklch(75% 0.2 var(--hud-accent-hue));
  clip-path: var(--corner-clip-path);
  /* animation: corner-pulse var(--particle-duration) ease-in-out infinite; */
}

/* Sync corner pulse with particle position - particles slow at corners */
.corner[data-corner='tl'] {
  animation-delay: 0s;
}

.corner[data-corner='tr'] {
  animation-delay: calc(var(--particle-duration) * -0.84);
}

.corner[data-corner='br'] {
  animation-delay: calc(var(--particle-duration) * -0.625);
}

.corner[data-corner='bl'] {
  animation-delay: calc(var(--particle-duration) * -0.375);
}

@keyframes corner-pulse {
  0%,
  8% {
    filter: brightness(1.3);
  }
  16%,
  100% {
    filter: brightness(1);
  }
}

.glint {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(170deg, black 0%, black 30%, var(--hud-glint-color) 50%, black 50%, black 100%);
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: 200% 200%;
  mix-blend-mode: plus-lighter;
  opacity: 0;
  clip-path: var(--hud-stroke-path);
  animation: glint-sweep 1.5s ease-out forwards;
  animation-delay: 0.5s;
}

@keyframes glint-sweep {
  0% {
    background-position: 100% 100%;
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    background-position: 0% 0%;
    opacity: 0;
  }
}

/* Orbital particle animation */
.particle {
  --particle-size: 4px;
  --particle-color: oklch(75% 0.2 var(--hud-accent-hue));
  --particle-blur: 1px;
  --particle-duration: 8s;
  --particle-opacity: 0.5;

  position: absolute;
  width: var(--particle-size);
  height: var(--particle-size);
  pointer-events: none;
  background: var(--particle-color);
  border-radius: 50%;
  mix-blend-mode: plus-lighter;
  opacity: var(--particle-opacity);
  filter: blur(var(--particle-blur));
  animation: particle-orbit var(--particle-duration) linear infinite;
  animation-delay: var(--particle-delay, 0s);
  offset-path: var(--hud-frame-path);
  offset-anchor: center;
}

/* Trail particles - one-shot animation on hover/focus */
.trail-particle {
  --trail-size: 6px;
  --trail-color: oklch(85% 0.25 var(--hud-accent-hue));
  --trail-blur: 2px;
  --trail-duration: 2.5s;

  position: absolute;
  width: var(--trail-size);
  height: var(--trail-size);
  pointer-events: none;
  background: var(--trail-color);
  border-radius: 50%;
  mix-blend-mode: plus-lighter;
  opacity: 0;
  filter: blur(var(--trail-blur));
  /* Animation paused by default, triggered on hover */
  animation: trail-orbit var(--trail-duration) ease-out 1 forwards paused;
  animation-delay: var(--trail-delay, 0s);
  offset-path: var(--hud-frame-path);
  offset-distance: 0%;
  offset-anchor: center;
}

/* Staggered trail particles for comet effect */
.trail-particle:nth-child(1 of .trail-particle) {
  --trail-delay: 0s;
  --trail-size: 6px;
}

.trail-particle:nth-child(2 of .trail-particle) {
  --trail-delay: 0.08s;
  --trail-size: 5px;
  --trail-blur: 1.5px;
}

.trail-particle:nth-child(3 of .trail-particle) {
  --trail-delay: 0.16s;
  --trail-size: 4px;
  --trail-blur: 1px;
}

/* Trigger trail animation on container hover/focus-within */
.container:hover .trail-particle,
.container:focus-within .trail-particle {
  animation-play-state: running;
}

/* Reset animation when not hovering - allows re-trigger */
.container:not(:hover):not(:focus-within) .trail-particle {
  animation: none;
}

@keyframes trail-orbit {
  0% {
    offset-distance: 0%;
    opacity: 0;
  }
  3% {
    opacity: 0.9;
  }
  /* Fast sweep around the frame */
  25% {
    offset-distance: 25%;
    opacity: 0.85;
  }
  50% {
    offset-distance: 50%;
    opacity: 0.7;
  }
  75% {
    offset-distance: 75%;
    opacity: 0.5;
  }
  90% {
    offset-distance: 90%;
    opacity: 0.25;
  }
  100% {
    offset-distance: 100%;
    opacity: 0;
  }
}

@keyframes particle-orbit {
  /* Top-left corner - slow (0-8%) */
  0% {
    offset-distance: 0%;
    opacity: 0;
  }
  2% {
    offset-distance: 2%;
    opacity: calc(var(--particle-opacity) * 0.3);
  }
  4% {
    offset-distance: 5%;
    opacity: calc(var(--particle-opacity) * 0.6);
  }
  6% {
    offset-distance: 8%;
    opacity: calc(var(--particle-opacity) * 0.9);
  }

  /* Top edge - fast (8-12%) */
  10% {
    offset-distance: 12%;
    opacity: var(--particle-opacity);
  }

  /* Top-right corner - slow (12-20%) */
  12% {
    offset-distance: 14%;
  }
  14% {
    offset-distance: 17%;
  }
  16% {
    offset-distance: 20%;
  }

  /* Right edge top - fast (20-25%) */
  20% {
    offset-distance: 25%;
  }

  /* Right edge bottom - fast (25-33%) */
  26% {
    offset-distance: 33%;
    opacity: calc(var(--particle-opacity) * 0.8);
  }

  /* Bottom-right corner - slow (33-42%) */
  30% {
    offset-distance: 36%;
    opacity: calc(var(--particle-opacity) * 0.4);
  }
  34% {
    offset-distance: 40%;
    opacity: 0;
  }
  38% {
    offset-distance: 42%;
  }

  /* Bottom edge - fast (42-58%) */
  46% {
    offset-distance: 50%;
  }
  54% {
    offset-distance: 58%;
  }

  /* Bottom-left corner - slow (58-67%) */
  58% {
    offset-distance: 61%;
  }
  62% {
    offset-distance: 64%;
  }
  66% {
    offset-distance: 67%;
  }

  /* Left edge bottom - fast (67-75%) */
  72% {
    offset-distance: 75%;
    opacity: calc(var(--particle-opacity) * 0.3);
  }

  /* Left edge top - fast (75-83%) */
  78% {
    offset-distance: 83%;
    opacity: calc(var(--particle-opacity) * 0.7);
  }

  /* Top-left corner approach - slow (83-92%) */
  84% {
    offset-distance: 87%;
    opacity: var(--particle-opacity);
  }
  88% {
    offset-distance: 90%;
    opacity: calc(var(--particle-opacity) * 0.8);
  }
  92% {
    offset-distance: 93%;
    opacity: calc(var(--particle-opacity) * 0.5);
  }

  /* Final approach - slow (93-100%) */
  96% {
    offset-distance: 97%;
    opacity: calc(var(--particle-opacity) * 0.3);
  }
  100% {
    offset-distance: 100%;
    opacity: 0;
  }
}
